import { AnimateSlideInContent } from '@components/animation/AnimateSlideIn/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  getCustomTextStyle,
  TextBody,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const PagesMain = styled.div`
  background-color: ${colors.white};
`

export const PagesSelectWrapper = styled.div`
  ${AnimateSlideInContent} {
    width: 100%;
  }
`

export const PagesSelect = styled.div`
  ${clamp('padding-top', 80, 120)}

  ${mq.tabletL} {
    display: none;
  }
  position: relative;
  
`

export const SelectTitle = styled.div`
  background: ${colors.white};
  color: ${colors.charcoal};
  padding: 2rem 0px;
  border-bottom: 1px solid ${colors.charcoal};
  font-size: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  span {
    flex: 1;
  }
  svg {
    width: 22px;
  }
`

export const SelectDropdown = styled.div`
  position: absolute;
  width: 100%;
  border: 1px solid ${colors.mist};
  font-size: 20px;
  background: ${colors.white};
  color: ${colors.charcoal};
  z-index: 10;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const SelectOption = styled.div`
  display: block;
  width: 100%;
  padding: 15px;
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.mist};
  }
  font-size: 20px;
  cursor: pointer;
  &[disabled] {
    color: ${colors.mist};
  }
`

export const PagesNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${clamp('padding-top', 80, 120)}

  ${mq.tabletLMax} {
    display: none;
  }

  > * + * {
    margin-top: 2rem;
  }
  button span {
    text-align: left;
  }
  button > div {
    transition: all 0.25s ease;
  }
  button:not(:disabled):hover > div {
    background-color: ${colors.white} !important;
    color: ${colors.charcoal} !important;
  }
  button:disabled > div {
    background-color: ${colors.white} !important;
    color: ${colors.charcoal} !important;
    opacity: 0.5;
  }
`

export const PagesWrapper = styled.div`

  ${mq.tabletLMax} {
    padding-top: 4rem;
  }

  ${mq.tabletL} {
    ${clamp('padding-top', 80, 120)}
  }
  min-height: 650px;
`

export const PageContent = styled.div`
  display: none;
  width: 100%;
  pointer-events: ${props => (props.show ? undefined : 'none')};
  .gatsby-image-wrapper {
    width: auto !important;
  }
  ${TextBody} {
    ${clamp('font-size', 16, 22)};
    line-height: 1.2;
  }
`

export const PageTitle = styled.h2`
  ${getCustomTextStyle(
    textStylesConfig.heading1Sans,
    textStylesConfig.heading2Sans
  )}
`
